/* import __COLOCATED_TEMPLATE__ from './layout.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./layout.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());